// src/client/components/profile-manager/detail-view/LocationSection.tsx

import InlineEditField from './InlineEditField';
import type { ProfileWithRelations } from '@shared/types';

interface LocationSectionProps {
  profile: ProfileWithRelations;
  onUpdate: (updates: Partial<ProfileWithRelations>) => Promise<void>;
}

export default function LocationSection({
  profile,
  onUpdate,
}: LocationSectionProps) {
  return (
    <div className="border rounded-lg p-4 bg-white">
      <h3 className="text-lg font-semibold mb-4">Location</h3>
      
      <InlineEditField
        label="City"
        value={profile.city}
        onSave={(value) => onUpdate({ city: value as string })}
        type="text"
      />
      
      <InlineEditField
        label="Country"
        value={profile.country}
        onSave={(value) => onUpdate({ country: value as string })}
        type="text"
      />
      
      <InlineEditField
        label="Location"
        value={profile.location}
        onSave={(value) => onUpdate({ location: value as string })}
        type="text"
        placeholder="Full location string..."
      />
    </div>
  );
}